"use strict";

angular.module("core")
.controller("PaymentMethodsBankAccountModalController", function(
    $scope, $attrs, $timeout, $sce, $q, $state, close, PaymentMethodsBankService, ReadOnlyPermissionService,
    FormError, FlashBag, common, gettextCatalog, Language, Rollbar, PatternService, PaymentMethodsService,
    appConfig, SETVALIDITY_DIGEST_TIMEOUT_DELAY, IS_MOBILE
) {
    var _this = this;
    $scope.isMobile = IS_MOBILE;
    $scope.pattern = PatternService;
    $scope.showMissingFieldsForm = null;
    $scope.missingCompanyDetailsData = {};
    $scope.companyDetailsData = {};
    $scope.showPreAuthorizedMessage = false;
    $scope.tokenTypes = {
        "IQ11": 'iq11',
        "MANUAL": 'manual'
    }
    $scope.bankAccountData = {
        "token_type": $scope.tokenTypes.IQ11
    };
    $scope.eventCatched = false;

    Language.initializeScope($scope, "language", null);

    window.addEventListener('message', receiveMessage, false);

    $scope.$on("$destroy", function() {
        window.removeEventListener('message', receiveMessage, false);
    });

    // window.addEventListener only works with static function and $scope.receiveMessage exists to be unit tested
    function receiveMessage(event) {
        $scope.receiveMessage(event);
    }

    $scope.receiveMessage = function(event) {
        if ($scope.eventCatched) {
            return;
        }

        var eventData = common.parseEventData(event);
        Rollbar.info(eventData);

        if ((eventData.Step === "LINK" || eventData.Success) && eventData.Token) {
            $scope.eventCatched = true;
            $scope.bankAccountData.token = eventData.Token;
            createBankAccount().then(function onSuccess() {
            }, function onError() {
                _this.chooseAccountSelectionMethod($scope.tokenTypes.MANUAL);
            }).finally(function() {
                $scope.eventCatched = false;
            });
        }
    };

    PaymentMethodsBankService.getClientAccount()
    .then(function onSuccess() {
        $scope.showMissingFieldsForm = false;
        getEmbedURL();
    }, function onError(response) {
        if (response.status === 404) {
            $scope.showMissingFieldsForm = response.data.has_missing_required_fields;
            if ($scope.showMissingFieldsForm) {
                $scope.companyDetailsData = response.data;
                $scope.missingCompanyDetailsData = angular.copy($scope.companyDetailsData);
            }
            else {
                getEmbedURL();
            }
        }
    });

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.updateCompanyDetails = function() {
        $scope.companyDetailsForm.$setSubmitted();
        FlashBag.clearAll();

        if ($scope.companyDetailsForm.$valid) {
            PaymentMethodsBankService.updateCompanyDetails($scope.companyDetailsData)
            .then(function onSuccess() {
                getEmbedURL();
                $scope.companyDetailsForm.$setPristine();
                $scope.showMissingFieldsForm = false;
                var message = gettextCatalog.getString("Company details was saved successfully.");
                FlashBag.alertWithContainer("success", "flash-payment-methods-bank-modal", message);
            }, function onError(response) {
                if (ReadOnlyPermissionService.handleResponseError(response)) {
                    _this.close(response);
                    FlashBag.apiError(response);
                }
                else {
                    var errorMessage = FlashBag.formatErrorResponse(response);
                    FlashBag.alertWithContainer("danger", "flash-payment-methods-bank-modal", errorMessage);
                }
            });
        }
        else {
            FormError.focus("companyDetailsForm");
        }
    };

    this.submitBankAccount = function() {
        $scope.bankAccountForm.$setSubmitted();
        FlashBag.clearAll();

        if ($scope.bankAccountForm.$valid) {
            createBankAccount();
        }
        else {
            FormError.focus("bankAccountForm");
        }
    }

    function createBankAccount() {
        FlashBag.clearAll();
        var deferred = $q.defer();

        PaymentMethodsBankService.createBankAccount($scope.bankAccountData)
        .then(function onSuccess(response) {
            $scope.bankAccountForm.$setPristine();
            $scope.showMissingFieldsForm = false;
            FlashBag.success(gettextCatalog.getString("Bank account was connected successfully."), true);

            if (appConfig.APP === "customer" && $state.current.name !== "configurePreAuthorizedPayment") {
                PaymentMethodsService.getPreAuthorizedPaymentMissingCount().then(function onSuccess(response) {
                    if (response.data && (response.data.has_missing_optional || response.data.has_missing_mandatory)) {
                        $scope.showPreAuthorizedMessage = true;
                    }
                    else {
                        _this.close(response);
                    }
                }, function onError() {
                    _this.close(response);
                });
            }
            else {
                _this.close(response);
            }

            deferred.resolve(response);
        }, function onError(response) {
            if (ReadOnlyPermissionService.handleResponseError(response)) {
                _this.close(response);
                FlashBag.apiError(response);
            }
            else {
                FormError.focus("bankAccountForm");
                var errorMessage = FlashBag.formatErrorResponse(response);
                FlashBag.alertWithContainer("danger", "flash-payment-methods-bank-modal", errorMessage);
            }

            deferred.reject(response);
        });
        return deferred.promise;
    }

    this.chooseAccountSelectionMethod = function(method) {
        $scope.bankAccountData.token_type = method;
    };

    function getEmbedURL() {
        PaymentMethodsBankService.getEmbedURL()
        .then(function onSuccess(response) {
            $scope.embedURL = $sce.trustAsResourceUrl(response.data.embed_url);
        }, function onError(response) {
            $scope.embedURL = '';
            var errorMessage = FlashBag.formatErrorResponse(response);
            FlashBag.alertWithContainer("danger", "flash-payment-methods-bank-modal", errorMessage);
        });
    }

    $scope.configurePreAuthorizedPayment = function() {
        _this.close();
        $state.go("paymentSettings", {tab: 1});
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/modals/payment-methods-bank-account.modal.js
// module id = 668
// module chunks = 0